import styled from '@emotion/styled';

export const CardContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.SurfaceWhite};
  border-radius: 8px;
`;
